import skrollTop from 'skrollTop';
import './easings';
export function scrollNav() {

  const getOffset = (el) => {
    const box = el.getBoundingClientRect();
    return {
      top: box.top + window.pageYOffset - document.documentElement.clientTop,
      left: box.left + window.pageXOffset - document.documentElement.clientLeft
    }
  }

  const getHeight = (el) => {
    const styles = window.getComputedStyle(el);
    const height = el.offsetHeight;
    const borderTopWidth = parseFloat(styles.borderTopWidth);
    const borderBottomWidth = parseFloat(styles.borderBottomWidth);
    const paddingTop = parseFloat(styles.paddingTop);
    const paddingBottom = parseFloat(styles.paddingBottom);
    return height - borderBottomWidth - borderTopWidth - paddingTop - paddingBottom;
  }
  
  const scrollButton = document.querySelectorAll('.js-scroll-button');
  const scrollTop = document.querySelectorAll('.js-scroll-top');
  const minusEl = document.querySelectorAll('.js-scroll-minus-el');
  let scrollTopArr = '';
  let setTimeoutClickScrolling = '';

  if(scrollButton && scrollTop) {

    const SCROLL_TOP_POSITION = function() {
      scrollTopArr = new Array;
      for (let i = 0; i < scrollTop.length; i++) {
        const target = scrollTop[i];
        const targetScrollOffset = getOffset(target);
        let minusElHeight = 0;
        if(minusEl) {
          for (let i = 0; i < minusEl.length; i++) {
            const el = minusEl[i];
            minusElHeight += getHeight(el);
          }
        }
        const targetScrollTop = targetScrollOffset.top - minusElHeight - 1;
        const targetScrollBottom = targetScrollTop + getHeight(target) + minusElHeight + 1;
        scrollTopArr[i] = [targetScrollTop, targetScrollBottom];
      }
    }

    const SCROLL_POSITION_CHECK = function() {
      const scTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
      for (let i = 0; i < scrollTopArr.length; i++) {
        const thisArr = scrollTopArr[i];
        const thisScrollTop = thisArr[0];
        const thisScrollBottom = thisArr[1];

        const thisScroll = scrollTop[i];
        const thisScrollName = thisScroll.dataset.scrolltop;
        const current = document.querySelector(`[data-scrollButton=${thisScrollName}]`);

        if(current) {
          if(thisScrollTop < scTop && thisScrollBottom > scTop) {
            current.classList.add('is-current');
          } else {
            current.classList.remove('is-current');    
          }
        }
      }
    }

    let scrollingTimer = '';
    for (let i = 0; i < scrollButton.length; i++) {
      const _scrollButton = scrollButton[i];
      _scrollButton.addEventListener('click', (e) => {
        e.preventDefault();
        clearTimeout(scrollingTimer);
        document.body.classList.add('is-click-scrolling');
        clearTimeout(setTimeoutClickScrolling);
        SCROLL_TOP_POSITION();
        SCROLL_POSITION_CHECK();
        const thisScrollName = _scrollButton.dataset.scrollbutton;
        const target = document.querySelector(`[data-scrollTop=${thisScrollName}]`);
        const targetOffset = getOffset(target);
        let minusElHeight = 0;
        if(minusEl) {
          for (let i = 0; i < minusEl.length; i++) {
            const el = minusEl[i];
            minusElHeight += getHeight(el);
          }
        }
        let targetOffsetTop = targetOffset.top - minusElHeight + 2;
        if(targetOffsetTop < 0) { targetOffsetTop = 0; }
        skrollTop.scrollTo({
          to: targetOffsetTop,
          easing: window.easings.easeInOutQuint,
          duration: 1200
        });
        scrollingTimer = setTimeout(() => {
          document.body.classList.remove('is-click-scrolling');
        }, 1200);
        document.body.classList.remove('is-nav-active');
      });
    }

    window.addEventListener('resize', () => {
      SCROLL_TOP_POSITION();
      SCROLL_POSITION_CHECK();
    });

    window.addEventListener('orientationchange', () => {
      SCROLL_TOP_POSITION();
      SCROLL_POSITION_CHECK();
    });

    window.addEventListener('scroll', SCROLL_POSITION_CHECK);

    SCROLL_TOP_POSITION();
    SCROLL_POSITION_CHECK();

  }
}